import { useHistory } from 'react-router-dom';

const ObservationFormReset = () => {
    const history = useHistory();
    history.replace('/observations/new');
    return null;
};

export default ObservationFormReset;
